module.exports = __webpack_public_path__ + "img/icon_energy.9e70f38c.png";